export enum PetTypeEnum {
  DOG = 1,
  CAT = 2,
  BOTH = 3
}
